import { gsap, ScrollTrigger } from 'gsap/all';

const OurWines = {
	init: function() {
		// console.log('OurWines specific code');

		$('.wine-collections-container-target').each(function(){

			
			let id = $(this).attr('id');

			let tl = gsap.timeline({
        scrollTrigger: {
          trigger: $('.' + id + "-wrap"),
          start: 'top 25%',
          end: 'bottom 25%',
          toggleClass: { className: "active", targets: ".nav-item." + id }
        }
      })
		})

	}
}

export default OurWines